import { TicketImage, Line, TextElement, BarcodeElement, Alignment, HorizontalRule, ImageElement } from 'ticket-image';
import moment from 'moment';
import { PLAYERCARDACTIVE, PRINTLARGER, NAMINGS, PRINTRECIEPTS, PRICE_DISPLAY }  from "./constants"
import { formatMoney } from './methods'

function h1(text) {
    return new Line(48, [new TextElement(text, Alignment.CENTER, 300, 36)]);
}
function h2(text) {
    return new Line(46, [new TextElement(text, Alignment.CENTER, 300, 28)]);
}
function h3(text) {
    return new Line(40, [new TextElement(text, Alignment.CENTER, 300, 24)]);
}
function h4(text) {
    return new Line(36, [new TextElement(text, Alignment.CENTER, 300, 20)]);
}
function formatPrice(price) {
    return `$${parseFloat(price)?.toFixed(2)}`;
}
function calculatePotentialReturn(bet) {
    const profit = bet.odds * (bet.stake - (bet.refund || 0));
    const calcProfit = parseFloat(profit)
    return potentialReturn(calcProfit)
}
function potentialReturn(v) {
    return (Math.floor(v*100).toFixed(0)/100).toFixed(2)
}
function formatNowTime() {
    const newTime = new Date();
    return moment(newTime, 'YYYY-MM-DD H:mm:ss').format('MMMM Do YYYY, h:mm:ss a');
}
function truncateRunnerName(v) {
    return v.substring(0, 18) + '...'
}
// function formatStartTime(time) {
//     return moment(time, 'YYYY-MM-DD H:mm:ss').format('LLL');
// }
function wagerDetails(bet, betName, venue) {
    const height = 30;
    const fontSize = 22;
    const c1 = 50;
    const c2 = 170;
    const c3 = 320;
    const c4 = 530;
    const c5 = 280;
    const c6 = 280
    const rName = truncateRunnerName(bet.runnerName)
    if (PRINTLARGER[venue]) {
      return [
        new Line(height,
          [
              new TextElement(`Cost: $${parseFloat(bet.stake)?.toFixed(2)}` , Alignment.CENTER, c5, fontSize),
          ]),
        new Line(height,
          [
              new TextElement("Type", Alignment.LEFT, c1, fontSize),
              new TextElement("Runner", Alignment.CENTER, c6, fontSize),
              new TextElement("Odds", Alignment.RIGHT, c4, fontSize),
          ]),
        new Line(height,
          [
            new TextElement(betName, Alignment.LEFT, c1, fontSize),
            new TextElement(`${bet.runnerNumber}. ${rName}`, Alignment.CENTER, c6, fontSize),
            new TextElement(formatPrice(bet.odds), Alignment.RIGHT, c4, fontSize),
          ])
      ];
    }
    else {
      return [
        new Line(height,
            [
                new TextElement("Cost", Alignment.LEFT, c1, fontSize),
                new TextElement("Type", Alignment.CENTER, c2, fontSize),
                new TextElement("Runner", Alignment.CENTER, c3, fontSize),
                new TextElement("Price", Alignment.RIGHT, c4, fontSize),
            ]),
        new Line(height,
            [
                new TextElement(`$${bet.stake}`, Alignment.LEFT, c1, fontSize),
                new TextElement(betName, Alignment.CENTER, c2, fontSize),
                new TextElement(`${bet.runnerNumber}. ${bet.runnerName}`, Alignment.CENTER, c3, fontSize),
                new TextElement(formatPrice(bet.odds), Alignment.RIGHT, c4, fontSize),
            ])
      ];
    }
}
let header = [];
export function setTicketHeader(imageUrl, height) {
    const image = new Image();
    image.onload = () => {
        header = [new Line(height || image.height, [new ImageElement(image)])];
        console.log(header);
    };
    image.src = imageUrl;
}
let ticketOptions = {};
export function setTicketOptions(options) {
    ticketOptions = options;
}
function betype (v, venue) {
    console.log('betType', v, venue)
    const display = PRICE_DISPLAY
    const type = display.find(c => (c.apiName === v || c.platformType === v) && c.venueName === venue)?.betType
    return type
    }
function generateBetReceipt(bet, terminalLocation, forCustomer, playerId, venue, startTime) {
    const betSet = betype(bet.winPlc, venue)
    let lines = header.concat([
        new Line(30, [new TextElement(bet.ticketId, Alignment.CENTER, 300, 24)]),
    ]);
    if (bet.status === 'Voucher') {
        lines.push(h1("* VOUCHER *"));
    }
    if (bet.refundOwing && bet.status !== 'Voucher') {
        if (forCustomer) {
            lines.push(h1("* CUSTOMER COPY *"));
        } else {
            lines.push(h1("* TELLER COPY *"));
        }
    }
    if (bet.payout && bet.status !== 'Voucher') {
      lines.push(h1("* CUSTOMER RECEIPT *"));
    }
    if (bet.payout && bet.status !== 'Voucher' ) {
      lines.push(h1(`${truncateShort(bet.trackName)} - Race ${bet.trackNumber}`));
      lines.push(h2(truncate(bet.raceName)));
      lines.push(new Line(15, [new HorizontalRule()]));
      lines = lines.concat(wagerDetails(bet, betSet, venue));
      lines.push(new Line(10, [new HorizontalRule()]));
    } 
    if (bet.status === 'Voucher') {
        lines.push(h1(`Voucher for: ${formatPrice(bet.payout)}`));
        lines.push(new Line(15, [new HorizontalRule()]));
    } else {
      lines.push(h1(`${truncateShort(bet.trackName)} - Race ${bet.trackNumber}`));
      lines.push(h2(truncate(bet.raceName)));
      lines.push(h3(`Start: ${startTime}`));
      lines.push(new Line(15, [new HorizontalRule()]));
      lines = lines.concat(wagerDetails(bet, betSet, venue));
      lines.push(new Line(10, [new HorizontalRule()]));
    }
    if (bet.refundOwing) {
        lines.push(h1(`Balance Refunded: ${formatPrice(bet.refundOwing)}`));
    }
    if (bet.payout && bet.status !== 'Voucher') {
        lines.push(h1(`Paid: ${formatPrice(bet.payout)}`));
    }
    if (!bet.refundOwing && bet.status !== 'Voucher') {
        if (calculatePotentialReturn(bet) > bet.branchCap && bet.capState) {
            lines.push(h4(`Return Exceeds payout cap.`));
            lines.push(h4(`Ticket must be redeemed at ${bet.branch}`));
        }
        lines.push(h4(`Potential Return:`), h1(`$${calculatePotentialReturn(bet)}`));
        lines.push(h3("* Deductions may apply"));
    }
    if (bet.reprint) {
        lines.push(h4(`REPRINTED: ${formatNowTime()}`));
    }
    if (bet.status === 'Voucher') {
        lines.push(h3(`Issued: ${formatNowTime()}`));
        lines.push(h4(`Expiry 12 months from date issued`));
    }
    if (bet.payout && bet.status !== 'Voucher') {
      lines.push(h4(`Cashed: ${formatNowTime()}`));
    }
    else {
        lines.push(h3(localTime(bet.time)));
    }
    if (ticketOptions?.expirationString) {
        lines.push(h3(ticketOptions.expirationString));
    }
    lines.push(h2(`Tmnl Loc: ${terminalLocation}`));
    if (PLAYERCARDACTIVE[venue] && playerId !== null) {
        lines.push(h3(`Player Id: ${playerId}`));
    }
    const barcode = new BarcodeElement(bet.ticketId.replace(/-/g, ''), 130);
    const reprintId = '' + bet?.reprint?.ticketId + bet?.reprint?.version
    const reprintBarcode = new BarcodeElement(reprintId.replace(/-/g, '')+bet?.reprint?.version, 130);
    barcode.setWidth(95, 2.5);
    reprintBarcode.setWidth(95, 2.5);
    
    lines.push(h3("BetMakers Technology Group"));
    if (bet.payout && bet.status !== 'Voucher') {
        lines.push(h3(`Congratulations, Have a great day!`));
    }
    else {
          if (bet.reprint) {
              lines.push(new Line(30, [new TextElement(reprintId, Alignment.CENTER, 300, 24)]));
              lines.push(new Line(40, [])); // spacer
              lines.push(new Line(150, [reprintBarcode]));
          } else {
              lines.push(new Line(30, [new TextElement(bet.ticketId, Alignment.CENTER, 300, 24)]));
              lines.push(new Line(40, [])); // spacer
              lines.push(new Line(150, [barcode]));
          }
      }
    lines.push(new Line(30, [])); // spacer
    const ti = new TicketImage(lines);
    return ti.renderToPNG(640, false);
}
export function generateTellerRefundReceipt(bet, terminalLocation, playerId, venue, startTime) {
    console.log('generateTellerRefundReceipt')
    return generateBetReceipt(bet, terminalLocation, false, playerId, venue, startTime);
}
export function generateCustomerBetReceipt(bet, terminalLocation, playerId, venue, startTime) {
    console.log('generateCustomerBetReceipt',"betId" , bet?.id, "trackName", bet?.trackName, "raceNumber", bet?.trackNumber, "raceName", bet?.raceName)
    return generateBetReceipt(bet, terminalLocation, true, playerId, venue, startTime);
}
export function generatePayoutReceipt(bet, terminalLocation, venue) {
    console.log('generatePayoutReceipt')
  if (PRINTRECIEPTS[venue]) return generateBetReceipt(bet, terminalLocation, true, null, venue);
}
export function generateVoucher(bet, terminalLocation, venue) {
    console.log('generateVoucher')
  return generateBetReceipt(bet, terminalLocation, true, null, venue, null);
}
/**
 * CASH POSITION
 */

function localTime(v) {
        return moment(v).format('MMMM Do YYYY, h:mm:ss a')
    }
function receiptLine(count, label, value) {
    const height = 30;
    const fontSize = 24;
    return new Line(height, [
        new TextElement(count, Alignment.RIGHT, 50, fontSize),
        new TextElement(label, Alignment.LEFT, 60, fontSize),
        new TextElement(value, Alignment.RIGHT, 550, fontSize),
    ]);
}
function receiptLine2(label, value) {
    const height = 30;
    const fontSize = 24;
    return new Line(height, [
        new TextElement(label, Alignment.LEFT, 50, fontSize),
        new TextElement(value, Alignment.RIGHT, 550, fontSize),
    ]);
}
function sumAmounts(transactions) {
    const total = transactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
    return total.toFixed(2) || 0
}
function truncate(text) {
    if (text.length > 25) {
        return text.substring(0, 25) + '...'
    }
    return text
}
function truncateShort(text) {
    if (text.length > 18) {
        return text.substring(0, 18) + '...'
    }
    return text
}
function printName (v, venue) {
  const name = NAMINGS
  const print = name.find(c => c.word === v  && c.venueName === venue)?.replaceWith
  return print || v
}
export function generateCashPosition(transactions, terminalLocation, venue, userName) {
    const PAYOUT = "BET_PAYOUT"
    const CANCEL = "BET_CANCELLED"
    const CASHIN = "BET_CASH_IN"
    const REFUND = "BET_REFUNDED"
    const VOUCHERREDEEM = "VOUCHER_REDEEMED"
    const VOUCHERCREATED = "VOUCHER_ISSUED"
    const DEPOSIT = "CLIENT_DEPOSIT"
    const WITHDRAW = "CLIENT_WITHDRAWAL"
    const REJECT = "BET_REJECTED"
    const sold = transactions?.filter((item) => item.type === CASHIN) || [];
    const paid = transactions?.filter((item) => item.type === PAYOUT) || [];
    const cancelled = transactions?.filter((item) => item.type === CANCEL) || [];
    const refunds = transactions?.filter((item) => item.type === REFUND || item.type === REJECT) || [];
    const draws = transactions?.filter((item) => item.reason === 'Draw' && item.amount > 0) || [];
    const returns = transactions?.filter((item) => item.reason === 'Return' && item.amount < 0) || [];
    const redemptions = transactions?.filter((item) => item.type === VOUCHERREDEEM && item.amount < 0) || [];
    const vouchers = transactions?.filter((item) => item.type === VOUCHERCREATED) || [];
    const deposits = transactions?.filter((item) => item.type === DEPOSIT && item.amount > 0) || [];
    const client_withdraws = transactions?.filter((item) => item.type === WITHDRAW && item.amount < 0) || [];
    const total = sumAmounts([].concat(sold, draws, returns, paid, cancelled, refunds, redemptions, deposits, client_withdraws));

    let lines = [
        h1(printName('Cash Position', venue)),
        receiptLine(`${sold.length}`, `Tickets Sold`, `${formatMoney(sumAmounts(sold))}`),
        receiptLine(`${paid.length}`, `Tickets Cashed`, `${formatMoney(sumAmounts(paid))}`),
        receiptLine(`${cancelled.length}`, `Tickets Cancelled`, `${formatMoney(sumAmounts(cancelled))}`),
        receiptLine(`${refunds.length}`, `Tickets Refunded`, `${formatMoney(sumAmounts(refunds))}`),
        receiptLine(`${draws.length}`, `Draws`, `${formatMoney(sumAmounts(draws))}`),
        receiptLine(`${returns.length}`, `Returns`, `${formatMoney(sumAmounts(returns))}`),   
    ]
    if(deposits.length > 0) {
        lines = lines.concat([ receiptLine(`${deposits.length}`, `Customer Deposit`, `${formatMoney(sumAmounts(deposits))}`)])
    }
    if(client_withdraws.length > 0) {
        lines = lines.concat([ receiptLine(`${client_withdraws.length}`, `Customer Withdraw`, `${formatMoney(sumAmounts(client_withdraws))}`)])
    }
    if(vouchers.length > 0) {
        lines = lines.concat([ receiptLine(`${vouchers.length}`, `Vouchers Created`, `${formatMoney(sumAmounts(vouchers))}`)])
    }
    if(redemptions.length > 0) {
        lines = lines.concat([ receiptLine(`${redemptions.length}`, `Voucher Redemptions`, `${formatMoney(sumAmounts(redemptions))}`)])
    }
    lines = lines.concat([
        new Line(10, [new HorizontalRule()]),
        receiptLine2(`CASH BALANCE`, `${formatMoney(total)}`),
        h3(formatNowTime()),
        receiptLine2(`Terminal Loc:`, terminalLocation),
        receiptLine2(`Username:`, userName),
        new Line(60, []),
    ])

    const ti = new TicketImage(lines);
    return ti.render({ width: 640, visible: false });
}
/**
 * Draw / Return
 */
function generateDrawReturn(transaction, terminalLocation, userName, forMoneyRoom) {
    const title = forMoneyRoom ? '* MONEY ROOM COPY *' : '* TELLER COPY *';
    let label = 'ERROR';
    switch (transaction.type) {
        case 'FLOATINCADJ':
        case 'Increase': label = 'Draw'; break;
        case 'FLOATDECADJ':
        case 'Decrease': label = 'Return'; break;
        case 'Voucher': label = 'Voucher'; break;
        case 'Deposit': label = 'Customer Deposit'; break;
        case 'Withdraw': label = 'Customer Withdraw'; break;
    }
    const ti = new TicketImage([
        h1(title),
        h1(`MANUAL TRANSACTION`),
        h3(`Amount: $${transaction.amount}`),
        h3(`Type: ${label}`),
        h3(`Terminal Loc: ${terminalLocation}`),
        h3(`Teller: ${userName}`),
        h2(`Date & Time`),
        h3(formatNowTime()),
        new Line(60, []),
    ]);
    return ti.render({ width: 640, visible: false });
}
function generateFundChangeReceipt(transaction, terminalLocation, userName, reference, fundChangeType) {
    const title = '* CUSTOMER RECEIPT *';
    const ti = new TicketImage([
        h1(title),
        h1(`MANUAL TRANSACTION`),
        h3(`Amount: $${transaction.amount}`),
        h3(`Type: Account ${fundChangeType}`),
        h3(`Terminal Loc: ${terminalLocation}`),
        h3(`Teller: ${userName}`),
        h2(`Date & Time`),
        h3(formatNowTime()),
        h3(`Ref: ${reference}`),
        new Line(60, []),
    ]);
    return ti.render({ width: 640, visible: false });
}
export function generateTellerDrawReturnReceipt(transaction, terminalLocation, userName) {
    return generateDrawReturn(transaction, terminalLocation, userName, false);
}
export function generateMoneyRoomDrawReturnReceipt(transaction, terminalLocation, userName) {
    return generateDrawReturn(transaction, terminalLocation, userName, true);
}
export function generateCustomerFundChangeReceipt(transaction, terminalLocation, userName, reference, fundChangeType) {
    return generateFundChangeReceipt(transaction, terminalLocation, userName, reference, fundChangeType);
}
/**
 * Ticket brand
 * isBackward : true means brand and eject, false means eat and keep ticket
 */
export function generateBrandImage(action, amount, userId, isBackward = true) {
    const canvasId = 'hiddenBrandCanvas';
    const ti = isBackward ? new TicketImage([
        new Line(32, [new TextElement(action, Alignment.CENTER, 400, 30)]),
        new Line(26, [new TextElement(formatMoney(amount), Alignment.CENTER, 400, 25)]),
        new Line(21, [new TextElement(userId, Alignment.CENTER, 400, 20)]),
        new Line(14, [new TextElement(moment(moment(), "YYYY-MM-DD H:mm:ss").format("LLL"), Alignment.CENTER, 400, 12)]),
    ]):
    // brand forward (eat/keep ticket)
    new TicketImage([
        new Line(32, [new TextElement(action, Alignment.LEFT, 80, 30)]),
        new Line(26, [new TextElement(formatMoney(amount), Alignment.LEFT, 80, 25)]),
        new Line(21, [new TextElement(userId, Alignment.LEFT, 80, 20)]),
        new Line(14, [new TextElement(moment(moment(), "YYYY-MM-DD H:mm:ss").format("LLL"), Alignment.LEFT, 80, 12)]),
    ])
    ;
    return ti.render({
        width: 640,
        height: 480,
        visible: false,
        canvasId: canvasId,
        rotateDegrees: 90,
        translateX:  -80,
        translateY: -ti.totalHeight() - 10,
    });
}